import axios from 'axios';

async function getStatus() {
    const response = await axios.get('admin/2fa/status', { withCredentials: true });
    return response?.data;
}

// setup_token is provided during forced login setup; omit it for the jwt-cookie flow.
async function setupInit(setup_token) {
    const body = setup_token ? { setup_token } : {};
    const response = await axios.post('admin/2fa/setup/init', body, { withCredentials: true });
    return response?.data;
}

// setup_token is provided during forced login setup; omit it for the jwt-cookie flow.
async function setupConfirm(totp_code, setup_token) {
    const body = setup_token ? { setup_token, totp_code } : { totp_code };
    const response = await axios.post('admin/2fa/setup/confirm', body, { withCredentials: true });
    return response?.data;
}

// POST — to change the method later, update only this function.
async function adminReset(account_id, totp_code) {
    const response = await axios.post(`admin/2fa/admin/reset/${account_id}`, { totp_code }, { withCredentials: true });
    return response?.data;
}

export default {
    getStatus,
    setupInit,
    setupConfirm,
    adminReset,
};
